
import { Add, Business } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { LinkButton } from "../../../Components/Atoms";
import { ModalLoader } from "../../../Components/Atoms/ModalLoader";
import {
  ScreenGreeting,
} from "../../../Components/Molecules";
import { InvoiceList } from "../../../Components/Molecules/Anticipation/InvoiceList";
import useCallAxios from "../../../Hooks/useCallAxios";

export const Anticipation = () => {
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);

  const context = "invoiceStatus";

  const {
    fetchGET: fetchStatus,
    requestLoading: loadingStatus,
    requestError: error,
    requestSuccess: success,
  } = useCallAxios({ context });

  useEffect(() => {
    fetchStatus({});
  }, [context]);

  useEffect(() => {
    if (error.GET != null && !error.GET) {
      setEnabled(false);
    }
  }, [error.GET]);

  useEffect(() => {
    if (success.GET != null && success.GET) {
      setEnabled(true);
    }
  }, [success.GET]);

  return (
    <>
      <ModalLoader
        open={loading || loadingStatus.GET}
        text={"Carregando informações"}
      />
      <ScreenGreeting
        title={"Antecipação de recebíveis"}
        subTitle={
          "Aqui estão os antecipáveis divididos por compradores. Cada comprador pode ter uma estratégia de antecipação diferente."
        }
      />
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        sx={{ mb: 2 }}
      >
        <LinkButton
          path={"/anticipation/addInvoice"}
          icon={<Add />}
          disabled={!enabled}
          tooltip="Cadastrar notas para antecipar recebíveis"
        >
          Adicionar notas
        </LinkButton>
        <LinkButton
          path={"/anticipation/buyers"}
          icon={<Business />}
          tooltip="Ver e gerenciar compradores para antecipação"
        >
          Compradores
        </LinkButton>
      </Stack>

      <InvoiceList setLoading={setLoading} enabled={enabled} />
    </>
  );
};
